module.exports = __webpack_public_path__ + "static/media/getinsha.a0b09075.png";